import React, { useState, useEffect } from "react";

import Cookies from 'js-cookie';

// reactstrap components
import { Card, CardBody, CardFooter, Row, Col, Button, Collapse } from "reactstrap";


// helpers
import { formateDateandTime } from "helpers/formats.js";
import moment from "moment";

// services
import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "services/acesso";

// views
import AcompanhamentoLista from "../../views/Acompanhamento/Lista";

//Component
import TextField from "../../components/TextField/TextField";
import { useAuth } from "context/auth";

function initialStateFiltro() {
  return {
    modalidade: "Todos"
  }
}
export default function Inicio({ history }) {
  const { session, setLoading } = useAuth();

  const [visualizarTela, setVisualizarTela] = useState(false)

  const [categorias, set_categorias] = useState([]);

  const [requerimentos, set_requerimentos] = useState([]);
  const [acao, set_acao] = useState("");

  const [categoria, set_categoria] = useState("");

  const [setupSolicitacao_Id, set_setupSolicitacao_Id] = useState(null);

  // options de modalidade
  const [optionsModalidade, setOptionsModalidade] = useState([
    { text: "Todos", value: "Todos" },
    { text: "RCC", value: "RCC" },
    { text: "RGG", value: "RGG" },
    { text: "RSS", value: "RSS" },
  ]);

  //State para abrir os card 
  const [abrirCard, setAbrirCard] = useState([]);

  //State para pegar a modalidade
  const [filtro, setFiltro] = useState(initialStateFiltro());

  const loadIndicadores = () => {
    setLoading(true);
    const savedModalidade = Cookies.get('filtroModalidade');
    // Checando se a modalidade está salva nos cookies
    api_GET(`categoria/GetListByExistsSetupSolicitacaoByUsuario/${session.usuario_Id}/${savedModalidade ?? "Todos"}`)
      .then(result => {
        if (savedModalidade) {
          setFiltro({ modalidade: savedModalidade });
        }
        set_categorias(result.data);

        let solitacoes = result.data.map(({ setupSolicitacoes }) => setupSolicitacoes)
          .flat()
          .map(({ setupSolicitacao_Id }) => setupSolicitacao_Id)
          .sort((a, b) => a - b);

        const _abriCard = solitacoes.reduce((acc, v) => {
          acc.push({
            setupSolicitacao_Id: v,
            visivel: false
          });
          return acc;
        }, []);

        setAbrirCard(_abriCard);
      })
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    loadIndicadores();
    ValidaAcessoFuncionalidadeAcao("AnaliseRequerimento.Visualizar", function (result) { setVisualizarTela(result) });
  }, []);

  const [listFilter, set_listFilter] = useState([])
  const openDetalhesIndicador = (tipo, setupSolicitacaoAcao_Id) => {
    set_listFilter(requerimentos.filter(f => f.setupSolicitacaoAcao.setupSolicitacao.segmento == categoria.segmento
      && f.setupSolicitacaoAcao.setupSolicitacao.categoria_Id == categoria.categoria_Id
      && f.fluxoCadastroEtapaAtual != null && f.fluxoCadastroEtapaAtual.tipo == tipo
      && f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == setupSolicitacaoAcao_Id));
  }

  const handleReturn = () => {
    set_requerimentos([]);
    setFiltro(initialStateFiltro());
    set_listFilter([]);
    set_detalhadoIndicador(null);
    loadIndicadores();
  }

  const [detalhadoIndicador, set_detalhadoIndicador] = useState(null);
  const loadDetalhadoIndicador = (_categoria, _acao, setupSolicitacao_Id) => {
    set_acao(_acao.acao);
    set_categoria(_categoria);
    set_setupSolicitacao_Id(setupSolicitacao_Id);
    let indicador = [];
    requerimentos.filter(f => f.setupSolicitacaoAcao.setupSolicitacao.segmento == _categoria.segmento
      && f.setupSolicitacaoAcao.setupSolicitacao.categoria_Id == _categoria.categoria_Id
      && f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == _acao.setupSolicitacaoAcao_Id && f.fluxoCadastroEtapaAtual != null).map(m => {
        if (indicador.filter(i => i.tipo == m.fluxoCadastroEtapaAtual.tipo).length == 0)
          indicador.push({ tipo: m.fluxoCadastroEtapaAtual.tipo, ordem: m.fluxoCadastroEtapaAtual.ordem, setupSolicitacaoAcao_Id: m.setupSolicitacaoAcao_Id });
      });

    for (var i in indicador) {
      indicador[i].qtdNoPrazo = requerimentos.filter(f => f.setupSolicitacaoAcao.setupSolicitacao.segmento == _categoria.segmento
        && f.setupSolicitacaoAcao.setupSolicitacao.categoria_Id == _categoria.categoria_Id
        && f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == _acao.setupSolicitacaoAcao_Id && f.fluxoCadastroEtapaAtual != null && f.fluxoCadastroEtapaAtual.tipo == indicador[i].tipo
        && moment(f.dataUltimaAcao).add('days', f.fluxoCadastroEtapaAtual.prazoResponsividade).isAfter(moment(new Date()), 'day') == true).length;
      indicador[i].qtdForaDoPrazo = requerimentos.filter(f => f.setupSolicitacaoAcao.setupSolicitacao.segmento == _categoria.segmento
        && f.setupSolicitacaoAcao.setupSolicitacao.categoria_Id == _categoria.categoria_Id
        && f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == _acao.setupSolicitacaoAcao_Id && f.fluxoCadastroEtapaAtual != null && f.fluxoCadastroEtapaAtual.tipo == indicador[i].tipo
        && moment(f.dataUltimaAcao).add('days', f.fluxoCadastroEtapaAtual.prazoResponsividade).isAfter(moment(new Date()), 'day') == false).length;
    }

    set_detalhadoIndicador(indicador);
    if (indicador.length == 0) {
      showMessage("Aviso", "Nenhum registro para ser exibido!", 'warning', null);
    }
  }


  function MontaCard(categoria, solicitacaoAcoes, setupSolicitacao_Id) {
    return solicitacaoAcoes?.filter(acao => acao.status == "Ativo")?.map((value, index) => (
      <Col lg="3" md="6" sm="6" key={index}>
        <Card className="card-stats card-dash">
          <CardBody>
            <Row>
              <Col lg="9" md="9" xs="6">
                <h6 className="text-left"><b>{value.identificacao}</b></h6>
                <p className="card-category" style={{ margin: "0", fontSize: "x-small" }}><i className="far fa-clock" /> Ultima Atualização:
                  {
                    requerimentos.filter(f => f.setupSolicitacaoAcao.setupSolicitacao.segmento == categoria.segmento
                      && f.setupSolicitacaoAcao.setupSolicitacao.categoria_Id == categoria.categoria_Id
                      && f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == value.setupSolicitacaoAcao_Id && f.dataUltimaAcao != null)
                      .sort(function (a, b) { return new Date(b.dataUltimaAcao) - new Date(a.dataUltimaAcao); }).length > 0 &&
                    formateDateandTime(requerimentos.filter(f => f.setupSolicitacaoAcao.setupSolicitacao.segmento == categoria.segmento
                      && f.setupSolicitacaoAcao.setupSolicitacao.categoria_Id == categoria.categoria_Id
                      && f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == value.setupSolicitacaoAcao_Id && f.dataUltimaAcao != null)
                      .sort(function (a, b) { return new Date(b.dataUltimaAcao) - new Date(a.dataUltimaAcao); }).reverse()[0].dataUltimaAcao)
                  }
                </p>
              </Col>
              <Col lg="3" md="3" xs="6">
                <div>
                  <strong className="text-left"><b>{requerimentos.filter(f => f.setupSolicitacaoAcao.setupSolicitacao.segmento == categoria.segmento
                    && f.setupSolicitacaoAcao.setupSolicitacao.categoria_Id == categoria.categoria_Id
                    && f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == value.setupSolicitacaoAcao_Id).length}</b></strong>
                </div>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <hr />
            <div className="text-center">
              <Button color="primary" onClick={() => loadDetalhadoIndicador(categoria, value, setupSolicitacao_Id)}>Detalhado</Button>
            </div>
          </CardFooter>
        </Card>
      </Col>
    ))
  }

  function MontaDetalhes(_categoria, _setupSolicitacao_Id) {
    return <Collapse isOpen={(categoria == _categoria && setupSolicitacao_Id == _setupSolicitacao_Id && acao != "") ? true : false}>
      <Col lg="12" style={{ margin: "10px 0px" }}>
        <div className="titulo-login" style={{ textTransform: "uppercase", padding: "0px" }}>{acao} </div>
        <div class="line-protocolo"></div>
      </Col>
      <Row xs="1" sm="1" md="5" style={{ margin: "20px 0" }}>
        {detalhadoIndicador != null && detalhadoIndicador.sort(function (a, b) { return a.ordem - b.ordem; }).map((m, key) => (
          <Col key={key}>
            <Card className="card-click" onClick={() => openDetalhesIndicador(m.tipo, m.setupSolicitacaoAcao_Id)}>
              <CardBody>
                <h5 className="text-center"><b>{m.tipo}</b></h5>
                <hr />
                <label className={"text-success"}>Dentro do Prazo: {m.qtdNoPrazo}</label><br />
                <label className={"text-danger"}>Fora do Prazo: {m.qtdForaDoPrazo}</label>
              </CardBody>
            </Card>
          </Col>
        ))
        }
      </Row>
    </Collapse>
  }

  const handleFiltroModalidade = (e) => {
    const { name, value } = e.target;

    setFiltro({
      ...filtro,
      [name]: value
    });

    setLoading(true);
    api_GET(`categoria/GetListByExistsSetupSolicitacaoByUsuario/${session.usuario_Id}/${value}`)
      .then(result => set_categorias(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));

    // Salva a modalidade nos cookies
    Cookies.set('filtroModalidade', value, { expires: 365, path: '/' });

  }

  function handleRequerimentoSetupSolicitacoes(setupSolicitacao) {
    let _cards = [...abrirCard];
    let _card = abrirCard.find(x => x.setupSolicitacao_Id === setupSolicitacao.setupSolicitacao_Id);
    _card.visivel = !_card.visivel;
    setAbrirCard([..._cards]);

    if (_card.visivel) {
      setLoading(true);
      api_GET(`requerimento/GetByAcompanhamentoSetupSolicitacao/${session.usuario_Id}/${setupSolicitacao.setupSolicitacao_Id}`)
        .then(result => {
          // Verifica se o requerimento já está na lista
          const existiRequerimento = requerimentos.findIndex(req => req.setupSolicitacaoAcao.setupSolicitacao_Id === setupSolicitacao.setupSolicitacao_Id);
          if (existiRequerimento === -1) {
            set_requerimentos([...requerimentos, ...result.data]);
          }
        })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
        .finally(() => setLoading(false));
    } else {
      set_requerimentos(requerimentos.filter(req => req.setupSolicitacaoAcao.setupSolicitacao_Id !== setupSolicitacao.setupSolicitacao_Id));
    }
  }

  return (
    <>
      {listFilter.length == 0 && visualizarTela &&
        <div className="content">
          <Row className="d-flex justify-content-end align-items-center">
            <Col lg={3}>
              <TextField
                name={"modalidade"}
                label={<span className="text-white">Modalidades</span>}
                type={"select"}
                options={optionsModalidade}
                value={filtro.modalidade}
                onChange={handleFiltroModalidade}
              />
            </Col>
          </Row>
          {categorias.map((m, _) => (
            <>
              {m?.setupSolicitacoes?.filter(s => s.status === "Ativo").map((s, index) => {
                const isOpen = abrirCard.some(item => item.setupSolicitacao_Id === s.setupSolicitacao_Id && item.visivel);
                return (
                  <Row key={index}>
                    <Card className="titulo-dash">
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleRequerimentoSetupSolicitacoes(s)}
                      >
                        <div lg="12" sm="12">
                          <h5 className="mb-0 mt-0">
                            <i className={m.classeIcone}></i> {m.sigla === "RSS"
                              ? <>{m.segmento.replace("Grande", "")} - {m.sigla} (Pessoa {s.pessoa}{s.pessoa === "Pública" ? (m.descricao.includes("Estadual/Federal") ? " - Estadual/Federal" : " - Municipal") : ""})</>
                              : <>{m.descricao.includes("RSS") ? m.segmento.replace("Grande", "") : m.segmento} - {m.descricao} (Pessoa {s.pessoa})</>}
                          </h5>
                        </div>
                        <div className="px-1">
                          <i className={`fas fa-arrow-${isOpen ? 'up' : 'down'}`} style={{ fontSize: "25px" }}></i>
                        </div>
                      </div>
                      {isOpen && (
                        <div className="card-principal">
                          <Row>
                            {MontaCard(m, s.solicitacaoAcoes, s.setupSolicitacao_Id)}
                          </Row>
                          <Row>
                            <Col lg="12" sm="12">
                              {MontaDetalhes(m, s.setupSolicitacao_Id)}
                            </Col>
                          </Row>
                        </div>
                      )}
                    </Card>
                  </Row>
                );
              })}
            </>
          ))}
        </div>
      }

      {listFilter.length > 0 &&
        <AcompanhamentoLista
          requerimentos={listFilter}
          handleReturn={handleReturn}
        />
      }
    </>
  );
}